<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_Prompt')"
    width="500px"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <div style="margin-left: 30px">
      <p style="font-size: 20px; font-weight: bold">{{ this.$t('SeaExport.SyncContainerInfoContent') }}</p>
      <p style="margin-left: 40px; font-size: 16px">{{ quantityTip }}</p>
      <p style="margin-left: 40px; font-size: 16px">{{ weightTip }}</p>
      <p style="margin-left: 40px; font-size: 16px">{{ cubageTip }}</p>
    </div>
    <div slot="footer">
      <el-button type="primary" no="ok" @click="ok()">{{ $t('common.btn.ok') }}</el-button>
      <el-button @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'

export default {
  name: 'SyncContainerInfoDialog',
  props: {
    visible: { type: Boolean, required: true },
    changePostFunc: { type: Function, default: () => {} }
  },
  data() {
    return {
      innerVisible: false,
      params: {},
      quantityTip: '',
      weightTip: '',
      cubageTip: ''
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.innerVisible = newVal
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    initInfo(params) {
      this.params = params
      // 填充提示信息
      this.quantityTip = this.$t('SeaExport.SyncContainerInfoQuantity', params.quantityArray)
      this.weightTip = this.$t('SeaExport.SyncContainerInfoWeight', params.weightArray)
      this.cubageTip = this.$t('SeaExport.SyncContainerInfoCubage', params.cubageArray)
    },
    ok() {
      this.params.cargoDoc.quantity = this.params.quantityArray[1]
      this.params.cargoDoc.weight = this.params.weightArray[1]
      this.params.cargoDoc.cubage = this.params.cubageArray[1]
      // 计费重量
      CargoDocUtil.calculateSEChargeWeight(this.params.cargoDoc)
      this.$emit('okCallback')
      this.innerVisible = false
    }
  }
}
</script>

